import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertWebEmailLinkUI from './insertwebemaillinkui';
import InsertWebEmailLinkEditing from './insertwebemaillinkediting';

export default class InsertWebEmailLink extends Plugin {
  static get pluginName() {
    return 'InsertWebEmailLink';
  }

  static get requires() {
    return [ InsertWebEmailLinkUI,  InsertWebEmailLinkEditing];
  }
}
